<template>
  <div>
    <mu-infinite-scroll :loading="loadShow" loadingText="拼命加载中" class="load" v-if="loadShow" />
    <div class="wrap myoreders-wrap personal-wrap flex-column">
      <div class="flex-item" v-for="(notCommentMsg,index) in notCommentGoodsListMsg" v-if="this.commId==null">
        <div class="orders-list detail">
          <div class="orders-list-item" style="margin: 0rem;">
            <mu-list style="border-bottom: 0;">
              <!-- v-if="shopList in notCommentMsg" -->
              <myOrdersItem v-for="(shopList,commentIndex) in notCommentGoodsListMsg" :cartitem="shopList" :isRightTriggle="'true'" :key="commentIndex">111
              </myOrdersItem>
            </mu-list>
          </div>
        </div>
        <div class="content">
          <div class="star-content">
            <div class="star-box" v-for="(starShow,starIndex) in notCommentMsg.commentStars">
              <p class="text">{{starShow.starTypeName}}</p>
              <!-- evaluateSever(star1,index,starIndex) -->
              <div class="star" v-for="starAdd in 5" :class="{'red': starAdd<=starShow.starScore}" @click="starAddBtn(starAdd,index,starIndex)"></div>
            </div>
          </div>
          <div class="tag-content">
            <p class="text-title">买家印象</p>
            <div class="tag-box">
              <mu-chip class="demo-chip" v-for="(tag,tagIndex) in notCommentMsg.commentTags" :class="{'primary':1==tag.selected}" :key="tagIndex" @click="selectTag(tagIndex,index)">{{tag.tagName}}</mu-chip>
            </div>
          </div>
          <div class="text-content">
            <p class="text-title">评价</p>
            <textarea maxlength="200" @input="notcommentInput(index)" v-model="notCommentMsg.commDesc" placeholder="商品是否给力？快分享您的购物心得吧~"></textarea>
            <p class="text-count">{{remnant}}/200字</p>
          </div>
        </div>
      </div>
      <div class="flex-item" v-if="this.commId!=null">
        <div class="orders-list detail">
          <div class="orders-list-item" style="margin: 0rem;">
            <mu-list style="border-bottom: 0;">
              <!--  v-if="shopList in notCommentMsg" -->
              <myOrdersItem :cartitem="getGoodsCommentEditShow" :isRightTriggle="'true'" :key="getGoodsCommentEditShow.commId">
              </myOrdersItem>
            </mu-list>
          </div>
        </div>
        <div class="content">
          <div class="star-content">
            <div class="star-box" v-for="(starShow,starEditIndex) in getGoodsCommentEditShow.commentStars">
              <p class="text">{{starShow.starTypeName}}</p>
              <!--  evaluateSever(star1,index,starIndex) -->
              <div class="star" v-for="starEdit in 5" :class="{'red': starEdit<=starShow.starScore}" @click="starEditBtn(starEdit,starEditIndex)"></div>
            </div>
          </div>
          <div class="tag-content">
            <p class="text-title">买家印象</p>
            <div class="tag-box">
              <mu-chip class="demo-chip" v-for="(tag,tagEditIndex) in getGoodsCommentEditShow.commentTags" :class="{'primary':1==tag.selected}" :key="tagEditIndex" @click="selectEditTag(tagEditIndex)">{{tag.tagName}}</mu-chip>
            </div>
          </div>
          <div class="text-content">
            <p class="text-title">评价</p>
            <textarea maxlength="200" @input="commentInput" v-model="getGoodsCommentEditShow.commDesc" placeholder="商品是否给力？快分享您的购物心得吧~"></textarea>
            <p class="text-count">{{remnant}}/200字</p>
          </div>
        </div>
      </div>
      <div class="bottom-btn-box">
        <div class="bottom-full-button">
          <mu-raised-button label="保存" fullWidth primary @click="goEvaluation" />
        </div>
      </div>
      <mu-dialog :open="evaluation" bodyClass="dialogBody successBody" actionsContainerClass="dialogActionsContainer fullContainer" @close="closeEvaluation">
        <p class="success-text"><img class="user-hear" src="/static/images/personal/operation_success_3x.png">评价提交成功！</p>
        <!-- <mu-flat-button slot="actions" @click="" primary label="否"/> -->
        <mu-flat-button slot="actions" primary label="确定" @click="closeEvaluation" />
      </mu-dialog>
    </div>
  </div>
</template>
<script type="text/javascript">
import menus from '@components/menus/menus';
import myOrdersItem from '@components/myOrdersItem/myOrdersItem';
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      loadShow: true,
      evaluation: false, //生产中、已发货  联系客服
      tags: [
        { name: "大品牌，值得信赖", id: 1 },
        { name: "服务好", id: 2 },
        { name: "质量真", id: 3 },
        { name: "赞", id: 9 },
        { name: "货真价实", id: 4 },
        { name: "外观漂亮大方", id: 5 },
        { name: "物美价廉", id: 6 },
        { name: "款式独特", id: 7 },
        { name: "做工精细", id: 8 }
      ],
      seltags: [],
      cartData: [{
        id: '1',
        title: "这个周末一起吃饭么?这个周末一起吃饭么?这个周末一起起吃饭么?这个周末一起吃饭么?",
        img: "/static/images/headImg.jpg",
        describe: "油漆门特权订金（特价门型不可用）",
        price: 99999,
        count: 1,
      }],
      comment: "",
      remnant: 200,
      serveStar: 0, //服务星数量
      priceStar: 0, //价格星数量
      goodsStar: 0, //商品星数量
      commId: this.$route.query.commId?this.$route.query.commId:null, //查询商品评价详情需传值;
      stOrderId: this.$route.query.stOrderId, //获取还为评价需传值;
      orderId: this.$route.query.orderId,
      notCommentGoodsListMsg: [], //获取还未平列表
      getGoodsCommentEditShow: {}, //获取当前评价信息
    }
  },
  methods: {
    ...mapActions({
      getNotCommentGoods: 'getNotCommentGoods', //获取还未评价的商品
      getGoodsComment: 'getGoodsComment', //获取当前商品评价详情
      modGoodsComment: 'modGoodsComment', //修改商品评价
      addGoodsComment: 'addGoodsComment', //新增商品评价
    }),
    //点击新增星星
    starAddBtn(starAdd, index, starIndex) {
      let obj = this.notCommentGoodsListMsg[index];
      obj.commentStars[starIndex].starScore = starAdd;
      this.$set(this.notCommentGoodsListMsg, index, obj);
    },
    //点击修改星星
    starEditBtn(starEdit, starEditIndex) {
      this.getGoodsCommentEditShow.commentStars[starEditIndex].starScore = starEdit;
    },
    //新增选择标签
    selectTag(tagIndex, index) {
      let obj = this.notCommentGoodsListMsg[index];
      if (obj.commentTags[tagIndex].selected == 1) {
        obj.commentTags[tagIndex].selected = 0;
      } else {
        obj.commentTags[tagIndex].selected = 1;
      }
      this.$set(this.notCommentGoodsListMsg, index, obj);
    },
    //修改选择标签
    selectEditTag(tagEditIndex) {
      if (this.getGoodsCommentEditShow.commentTags[tagEditIndex].selected == 1) {
        this.getGoodsCommentEditShow.commentTags[tagEditIndex].selected = 0;
      } else {
        this.getGoodsCommentEditShow.commentTags[tagEditIndex].selected = 1;
      }
    },
    //评论输入是检测字数
    commentInput() {
      var txtVal = this.getGoodsCommentEditShow.commDesc.length;
      this.remnant = 200 - txtVal;
    },
    notcommentInput(index){
      var txtVal = this.notCommentGoodsListMsg[index].commDesc.length;
      this.remnant = 200 - txtVal;
    },
    closeEvaluation() {
      this.evaluation = false;
      this.$router.push({
        path: '/main/mycomments'
      })
    },
    //提交评判断(新增或者修改)
    goEvaluation(id) {
      if (this.commId == null) {
        let upMsg = []; //提交表单的值
        this.notCommentGoodsListMsg.forEach((item, index) => {
          let commentTagsAdd = [];
          item.commentTags.forEach(selectAdd => {
            let changeAdd = {
              tagId: selectAdd.selected == 1 ? selectAdd.tagId : null,
            };
            commentTagsAdd.push(changeAdd);
          });
          let msgAllLiset = {
            instSkuId: item.instSkuId,
            goodsId: item.goodsId,
            skuId: item.skuId,
            commentStars: item.commentStars,
            commentTags: commentTagsAdd,
            commentDesc: item.commDesc,
          };
          upMsg.push(msgAllLiset);
          return upMsg;
        });
        this.getAddGoodsComment(this.stOrderId, this.orderId, upMsg);
      } else if (this.commId != null) {
        this.getGoodsCommentEditShow;
        let commentTagsEdit = [];
        this.getGoodsCommentEditShow.commentTags.forEach((selectItem, selectindex) => {
          let changeTags = {
            tagId: selectItem.selected == 1 ? selectItem.tagId : null,
          };
          commentTagsEdit.push(changeTags);
          return commentTagsEdit;
        });
        let editMsg = {
          instSkuId: this.getGoodsCommentEditShow.instSkuId,
          goodsId: this.getGoodsCommentEditShow.goodsId,
          skuId: this.getGoodsCommentEditShow.skuId,
          commentStars: this.getGoodsCommentEditShow.commentStars,
          commentTags: commentTagsEdit,
          commentDesc: this.getGoodsCommentEditShow.commDesc,
        };
        this.getModGoodsComment(this.commId, editMsg);
      }
    },
    //修改评价......
    getModGoodsComment(commId, getGoodsCommentEditShow) {
      this.modGoodsComment([commId, getGoodsCommentEditShow]).then(res => {
        //console.log
        ("修改商品评价成功", res);
        this.evaluation = true;
      }).catch(error => {})
    },
    //获取还未评价的商品
    getNotCommentGoodsList(stOrderId) {
      this.getNotCommentGoods(stOrderId).then(res => {
        this.loadShow = false; //关闭加载
        this.notCommentGoodsListMsg = res; //保存为评价列表
        this.notCommentGoodsListMsg.forEach(item => {
          item.instSkuId = item.instSkuId ? item.instSkuId : null;
          item.goodsId = item.goodsId ? item.goodsId : null;
          item.skuId = item.skuId ? item.skuId : null;
          item.commentTags = item.commentTags ? item.commentTags : [];
          item.commentStars = item.commentStars ? item.commentStars : [];
          item.commentDesc = item.commentDesc ? item.commentDesc : null;
        });
      });
    },
    //获取当前商品评价详情
    getGoodsCommentMsg(commId) {
      this.getGoodsComment(this.commId).then(res => {
        this.loadShow = false;
        this.getGoodsCommentEditShow = res.target;
        this.commentInput();
      });
    },
    //新增当前商品详情
    getAddGoodsComment(stOrderId, orderId, upMsg) {
      this.addGoodsComment([stOrderId, orderId, upMsg]).then(res => {
        this.evaluation = true;
      })
    },
  },
  watch: {},
  created() {
    this.getNotCommentGoodsList(this.stOrderId); //获取还为评价的商品
    if(this.commId){
      this.getGoodsCommentMsg(this.commId); //获取当前商品详情
    }
    
  },
  components: {
    menus,
    myOrdersItem
  }
}

</script>
<style lang="scss" rel="stylesheet/scss">
@import 'personal.scss';
.content {
  color: #8A8A8A;
  @include font-dpr(12px);
  background: #fff;
  .text-title {
    margin-bottom: 0.3rem;
  }
  .star-content {
    padding-left: 0.4rem;
    padding-top: 0.4rem;
    @include bdT(#e5e5e5, top);
    .star-box {
      height: 0.8rem;
      clear: both;
      .text {

        float: left;
        width: 2rem
      }
      .star {
        float: left;
        height: 0.4rem;
        width: 0.4rem;
        margin-right: 0.3rem;
        background: url("/static/images/personal/star_gray_3x.png") no-repeat;
        background-size: 0.4rem
      }
      .star.red {
        background: url("/static/images/personal/star_red_3x.png") no-repeat;
        background-size: 0.4rem
      }
      .grad {
        color: #c5c5c5;
      }
    }
  }

  .tag-content {
    @include bdT(#e5e5e5,
    top);
    padding: 0.4rem 0.4rem 0.1rem 0.4rem;
    .tag-box {
      .demo-chip {
        margin-right: 0.25rem;
        background: #FFF;
        border: 1px solid #DADADA;
        margin-bottom: 0.3rem;
        border-radius: 0.4rem;
        line-height: 0.8rem;
        padding: 0 0.3rem;
      }
      .primary {
        color: #222;
        border: 1px solid #E60012;
      }
    }
  }

  .text-content {
    position: relative;
    @include bdT(#e5e5e5,
    top);
    padding: 0.4rem 0.4rem 0.4rem 0.4rem;
    textarea {
      line-height: 1.5;
      width: 100%;
      min-height: 2.5rem;
      padding: 0.3rem;
      background: #f7f7f7;
      border: 1px solid #CFCFCF;
      @include sInput(#f7f7f7,
      left,
      #333);
      resize: none;
    }
    .text-count {
      position: absolute;
      bottom: 0.7rem;
      right: 0.7rem;
    }
  }
}

</style>



// WEBPACK FOOTER //
// evaluation.vue?6b4c988c